import { RCCServicesApi } from "react-common-components";
import { IGroupersIndicatorsList } from "src/pages/Indicators/Panel/components/interface";
import IFiltersIndicatorsPanel, { IGroupersIndicatorsSelect } from "src/pages/Indicators/Panel/interface";
import formatDate from "src/utils/formatDate";
import { IListIndicatorsChart } from "./interface";

const executeQueryListOfIndicatorsChart = async (groupersSelect: IGroupersIndicatorsSelect, groupers: IGroupersIndicatorsList, filters: IFiltersIndicatorsPanel = {} as IFiltersIndicatorsPanel) => {
	const {data} = await RCCServicesApi.getRequest({
		method: "Indicators/ListPresentationPanel",
		urlParameters: {
			...groupersSelect,
			id: groupers.grouperId === 0 ? "" : groupers.grouperId,
			id2: groupers.grouperId2 || "",
			id3: groupers. grouperId3 || "",
			id4: groupers.grouperId4 || "",
			f: filters.f || "",
			responsible: filters.responsible || "",
			presentationGroup: filters.presentationGroup,
			sector: filters.sector || "",
			startDate: filters.startDate ? formatDate(filters.startDate) : "",
			endDate: filters.endDate ? formatDate(filters.endDate) : "",
			classification: filters.classification || "",
			tags: filters.tags || ""
		}
	});
	const listIndicatorsChart = data as IListIndicatorsChart[];

	return listIndicatorsChart;
};

export default executeQueryListOfIndicatorsChart;
